module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('div', {
    staticClass: "header-wrapper pagedetail animate fadeIn"
  }, [_c('h1', {
    staticClass: "pagedetail__title"
  }, [_vm._v("กองผ้าป่า " + _vm._s(_vm.form.title))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 pd-sm-0"
  }, [_c('page-card', {
    ref: "card",
    attrs: {
      "title": _vm.form.title,
      "message": _vm.form.message,
      "owner": _vm.form.owner,
      "province": _vm.form.provinceObject,
      "school": _vm.form.schoolObject,
      "image": _vm.page.image,
      "editing": _vm.editing,
      "page": _vm.page
    },
    on: {
      "edit": _vm.edit,
      "cancel": _vm.cancelEdit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "block-border radius block shadow"
  }, [_c('page-form', {
    attrs: {
      "submit-button-text": "บันทึก"
    },
    on: {
      "submit": _vm.update
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "block-border radius block shadow mb-15"
  }, [_c('div', {
    staticClass: "flex flex-between"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._v("ยอดบริจาค\n                "), _c('br'), (!_vm.page.data.total_product_price) ? _c('span', {
    staticClass: "text-remark"
  }, [_vm._v("ยังไม่มีเพื่อนร่วมบริจาค")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("comma")((_vm.page.data.total_product_price || 0))))]), _vm._v(" บาท")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "text-center mt-15"
  }, [_vm._v("แชร์กองผ้าป่าของคุณ")]), _vm._v(" "), _c('div', {
    staticClass: "share text-center"
  }, [_c('vue-goodshare-facebook', {
    attrs: {
      "page_url": _vm.url + '?v=' + _vm.page.changed,
      "title_social": "Facebook",
      "has_icon": ""
    }
  }), _vm._v(" "), _c('share-line-button', {
    attrs: {
      "page_url": _vm.url + '?v=' + _vm.page.changed,
      "title_social": "Line",
      "has_icon": ""
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block-border radius shadow mb-15 hide"
  }, [(!_vm.page.data.total_product_price) ? _c('div', {}, [_vm._m(0), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "choices": [200, 500, 2500, 5000],
      "custom": true,
      "defaults": 500,
      "minimum": 20,
      "product": _vm.product
    },
    on: {
      "change": _vm.amountChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('product-donate-type', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.donateType),
      callback: function($$v) {
        _vm.donateType = $$v
      },
      expression: "donateType"
    }
  }), _vm._v(" "), _c('donor-info', {
    model: {
      value: (_vm.attributes.info),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "info", $$v)
      },
      expression: "attributes.info"
    }
  }), _vm._v(" "), (_vm.product) ? _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "buy-now-text": "บริจาค",
      "stockAvailable": false,
      "attributes": _vm.attributes,
      "product": _vm.product,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "donate__wrapper"
  }, [_c('button', {
    staticClass: "btn btn--purple",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])]), _vm._v(" "), (_vm.page) ? _c('donor-list', {
    staticClass: "col-md-6",
    attrs: {
      "page": _vm.page
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n                ร่วมเป็นคนแรกบริจาค"), _c('br'), _vm._v("ให้กองผ้าป่านี้\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11a6defe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDetail.vue
// module id = 1116
// module chunks = 0